import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { leadGeneration, notify, OtpVerify, verifyUser } from "../../API/API";
import { autoLogin, showToast } from "../../components/common/Util/Util";

const CheckEligibilityPopUp = ({
  showCheckEligibilityPopup,
  setShowCheckEligibility,
  setEligibilityResponse,
  businessAge,
  businessType,
  emiHistory,
  annualProfit,
  totalSales,
  entityType,
  fundsUsed,
  setCustomerNum,
  customerNum,
  setEntityName,
  entityName,
}) => {
  const dispatch = useDispatch();
  const ip = useSelector((state) => state.user.ip);
  const cordinates = useSelector((state) => state.user.cordinates);
  const userData = useSelector((state) => state.user.user);
  // const [customerNum, setCustomerNum] = useState("");
  // const [entityName, setEntityName] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // const eligibilityPercentage = (totalSales / 500) * 100; // Convert sales to percentage for gauge

  const notificationRequest = {
    userId: userData.ID || userData.id,
    title: "New Lead Generated",
    content: `A new loan eligibility lead has been generated by ${
      entityName || userData?.Name || ""
    }.`,
    createdByRole: "USER",
    type: "leadGeneration",
    action: "View Lead",
    actionUrl: "/leads",
    unread: true,
  };
  const handleLead = () => {
    if (otp === "") {
      showToast("Please enter the OTP", "error");
      return;
    } else if (otp?.length !== 4) {
      showToast("Please enter the complete OTP", "error");
      return;
    }
    setIsLoading(true);
    const verifyOtpRequest = {
      mobileNumber: customerNum?.replace(/-/g, ""),
      mobileOtp: otp,
    };
    OtpVerify(verifyOtpRequest)
      .then((res) => {
        if (res?.statusCode === 200 && res?.message === "OTP Verified") {
          const leadRequest = {
            mobileNumber: customerNum?.replace(/-/g, ""),
            leadType: "elical",
            ip: ip,
            longitude: String(cordinates?.lng ? cordinates?.lng : ""),
            latitude: String(cordinates?.lat ? cordinates?.lat : ""),
            eliCal: {
              entityType: entityType,
              businessType: businessType,
              businessAge: businessAge,
              totalSales: (totalSales / 100000).toFixed(2),
              annualProfit: (annualProfit / 100000).toFixed(2),
              fundsUsed: fundsUsed,
              emiHistory: emiHistory,
              entityName: entityName,
            },
          };
          leadGeneration(leadRequest)
            .then((res) => {
              setIsLoading(false);
              if (res.statusCode === 200) {
                setEligibilityResponse(res?.result);
                notify(notificationRequest);
                autoLogin(res?.result, dispatch);
                handleClose();
              } else {
                showToast(res?.message, "error");
              }
            })
            .catch((err) => {
              showToast("Oops! Something went wrong.", "error");
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
          showToast(res?.message, "error");
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };
  const onSubmit = (e) => {
    setIsLoading(true);
    let checkUserRequest = {
      mobileNumber: customerNum?.replace(/-/g, ""),
      ip: ip,
      longitude: String(cordinates?.lng ? cordinates?.lng : ""),
      latitude: String(cordinates?.lat ? cordinates?.lat : ""),
      screen: "eligibility",
    };
    verifyUser(checkUserRequest)
      .then((res) => {
        if (res?.statusCode === 200) {
          showToast(res.message, "success");
          setOtpSent(true);
          setIsLoading(false);
        } else if (res?.statusCode === 208) {
          // Instead of automatically processing the lead, require OTP verification
          showToast("Please verify your mobile number", "info");
          setOtpSent(true);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          showToast(res?.message, "error");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        showToast("Oops! Something went wrong.", "error");
      });
  };
  const handleClose = () => {
    setShowCheckEligibility(false);
    setOtpSent(false);
    setOtp("");
    setIsLoading(false);
    setCustomerNum("");
    setEntityName("");
  };
  return (
    <Dialog
      open={showCheckEligibilityPopup}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px", // Curved edges
          padding: "20px",
        },
      }}
    >
      <DialogContent>
        {/* Flexbox Section */}
        <Box display="flex" alignItems="center" justifyContent="space-evenly">
          <Box flex={1}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#004AAD" }}
            >
              Check Your Eligibility
            </Typography>
            <Typography
              variant="body1"
              mt={1}
              sx={{ fontStyle: "italic", fontSize: "0.8rem", width: "250px" }}
            >
              Before we show your eligibility results, please provide your
              details.
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center">
            <img
              src="/eligibilityPopImg.png"
              alt="Popup Img"
              style={{ maxWidth: "100px" }}
            />
          </Box>
        </Box>

        {/* Phone Number Input */}
        {!otpSent ? (
          <Box mt={3} display="flex" justifyContent="center">
            <Controller
              name="mobileNumber"
              control={control}
              rules={{
                required: "Mobile number is required",
                validate: (value) => {
                  const digitsOnly = value.replace(/\D/g, "");
                  return (
                    digitsOnly.length === 10 ||
                    "Mobile number must be 10 digits"
                  );
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  label={
                    <>
                      Mobile Number
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  type="tel"
                  autoFocus
                  value={customerNum}
                  disabled={isLoading}
                  autoComplete={"false"}
                  slotProps={{
                    htmlInput: {
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    },
                    inputLabel: { shrink: true },
                  }}
                  onInput={(e) => {
                    e.target.value.replace(/^\s+/, "");
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    e.target.value = e.target.value.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "$1-$2-$3"
                    );
                    field.onChange(e);
                    setCustomerNum(e.target.value);
                  }}
                  sx={{
                    marginBottom: "1rem",
                    "& input::placeholder": {
                      color: "#A8A8A8", // Placeholder color
                    },
                  }}
                  error={!!errors.mobileNumber}
                  placeholder="XXX-XXX-XXXX" // Placeholder format
                  helperText={errors.mobileNumber?.message}
                />
              )}
            />
          </Box>
        ) : (
          <Box mt={3} display="flex" justifyContent="center">
            <Controller
              name="otp"
              control={control}
              rules={{
                required: "OTP is required",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  value={otp}
                  required
                  fullWidth
                  label="Enter Your OTP"
                  type="num"
                  slotProps={{
                    htmlInput: {
                      maxLength: 4,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    },
                    inputLabel: { shrink: true },
                  }}
                  autoFocus
                  disabled={isLoading}
                  onChange={(e) => {
                    setOtp(e?.target?.value);
                  }}
                  sx={{
                    marginBottom: "1rem",
                    "& input::placeholder": {
                      color: "#A8A8A8", // Placeholder color
                    },
                  }}
                  error={!!errors.mobileNumber}
                  placeholder="Enter your OTP" // Placeholder format
                  helperText={errors.mobileNumber?.message}
                />
              )}
            />
          </Box>
        )}

        {!otpSent && (
          <Box display="flex" justifyContent="center">
            <Controller
              name="entityName"
              control={control}
              rules={{
                required: "Entity name is required",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  required
                  fullWidth
                  label="Entity Name"
                  type="text"
                  value={entityName}
                  disabled={isLoading}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/^\s+/, "");
                    setEntityName(e.target.value);
                    field.onChange(e.target.value);
                  }}
                  sx={{
                    marginBottom: "1rem",
                    "& input::placeholder": {
                      color: "#A8A8A8",
                    },
                  }}
                  error={!!errors.entityName}
                  placeholder="Enter your entity name"
                  helperText={errors.entityName?.message}
                />
              )}
            />
          </Box>
        )}

        {/* Submit Button */}
        {!otpSent ? (
          <Box mt={2} display="flex" justifyContent="center">
            <Button
              variant="contained"
              fullWidth
              disabled={isLoading}
              sx={{
                maxWidth: "350px",
                backgroundColor: "#004AAD",
                textTransform: "none",
                padding: 1.5,
                position: "relative",
              }}
              onClick={handleSubmit(onSubmit)}
            >
              {isLoading ? (
                <>
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "white",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-12px",
                      marginLeft: "-12px",
                    }}
                  />
                  <span style={{ visibility: "hidden" }}>Proceed</span>
                </>
              ) : (
                "Proceed"
              )}
            </Button>
          </Box>
        ) : (
          <Box mt={2} display="flex" justifyContent="center">
            <Button
              variant="contained"
              fullWidth
              disabled={isLoading}
              sx={{
                maxWidth: "350px",
                backgroundColor: "#004AAD",
                textTransform: "none",
                padding: 1.5,
                position: "relative",
              }}
              onClick={() => handleLead()}
            >
              {isLoading ? (
                <>
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "white",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-12px",
                      marginLeft: "-12px",
                    }}
                  />
                  <span style={{ visibility: "hidden" }}>Verify</span>
                </>
              ) : (
                "Verify"
              )}
            </Button>
          </Box>
        )}

        {/* Text Button */}
        <Box mt={1} display="flex" justifyContent="center">
          <Button
            variant="text"
            disabled={isLoading}
            sx={{ maxWidth: "350px", color: "#004AAD", textTransform: "none" }}
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
        </Box>

        {/* Additional Text */}
        <Box mt={2} display="flex" justifyContent="center">
          <Typography sx={{ fontStyle: "italic", fontSize: "0.8rem" }}>
            By proceeding, you agree to our terms & conditions.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CheckEligibilityPopUp;
